import React from 'react';
import { useSelector } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import {
  authRoute,
  draftPPIsRoute,
  loginRoute,
  logoutRoute,
  newDishesRoute,
  newIngredientsRoute,
  ppiCreateRoute,
  ppiInProgressRoute,
  ppsiCreateRoute,
  ppsiCreateVariantRoute,
  // globalVariantPpiRoute,
  draftPPSIsRoute,
  ppsiInProgressRoute,
  newGlobalIngredientsRoute,
  ppiCreateFromExistingRoute,
  ppiCreateVariantRoute,
  newGlobalDishesRoute,
  ppsiCreateFromExistingRoute,
  ppiPublishedRoute,
  publishedPPIsRoute,
  ppsiPublishedRoute,
  approvedPPSIsRoute,
  publishedPPSIsRoute,
  unpublishedPpsisRoute,
  unpublishedPpisRoute,
  ppiCreateFromExistingSelectPpiRoute,
  ppiCreateFromPublishedPpiRoute,
  excludedDishesRoute,
  excludedIngredientsRoute,
  globalWaitingReviewRoute,
  globalMarketReviewRoute,
  globalReviewApprovalRoute,
  approvalStatusPPSIsRoute,
  updatesRoute,
  dataReportRoute,
  totalRangeDishStatisticsRoute,
  coWorkerEngagementReportRoute,
  coWorkerEngagementReportMarketRoute,
  coWorkerEngagementReportListRoute,
  globalSearchRoute,
  uploadFileRoute,
  ppsiCreateFromPublishedPpsiRoute,
  bomReportNirRoute,
  globalPpsisRoute,
  feedbackRoute,
  globalPpsisNirRoute,
  globalPppsiDetailsNirRoute,
  ppsiCreateFromGlobalNirRoute,
  marketSettingsRoute
  // newUpdatesRoute
} from '../../routes';
import DishesExcludedView from '../../views/DishesExcludedView';
import IngredientsExcludedView from '../../views/IngredientsExcludedView';
import GlobalReviewSummary from 'views/GlobalReviewSummaryView';
import WaitingForGlobalReview from 'views/WaitingForGlobalReview';
import PrivateRoute from './PrivateRoute';
import ProtectedRoute from './ProtectedRoute';
import LoginView from '../../features/loginSystem/LoginView';
import LogoutView from '../../features/loginSystem/LogoutView';
import AuthView from '../../features/loginSystem/AuthView';
import NewIngredientsView from '../../views/NewIngredientsView';
import NewDishesView from '../../views/NewDishesView';
import PpiCreateView from '../../views/PpiCreateView';
import PpiEditView from '../../views/PpiEditView';
import PpiDraftListView from '../../views/PpiDraftListView';
import PpsiCreateView from '../../views/PpsiCreateView';
import PpsiCreateVariantView from 'views/PpsiCreateVariantView';
import NotFoundView from '../../views/NotFoundView';
import PpsiDraftListView from '../../views/PpsiDraftListView';
import PpsiEditView from '../../views/PpsiEditView';
import NewIngredientsGlobalView from '../../views/NewIngredientsGlobalView';
import PpiCreateFromExistingView from '../../views/PpiCreateFromExistingView';
import StartPage from '../../views/StartPage';
import NewGlobalPpsisView from '../../views/NewDishesGlobalView';
import PpsiCreateFromExistingView from '../../views/PpsiCreateFromExistingView';
import PpiPublishedView from '../../views/PpiPublishedView';
import PpiPublishedListView from '../../views/PpiPublishedListView';
import PpsiPublishedView from '../../views/PpsiPublishedView';
import PpsiApprovedListView from '../../views/PpsiApprovedListView';
import PpsiPublishedListView from '../../views/PpsiPublishedListView';
import UnpublishedDishListView from '../../views/UnpublishedDishListView';
import UnpublishedIngredientListView from 'views/UnpublishedIngredientListView';
import PpiCreateFromExistingSelectPpiView from '../../views/PpiCreateFromExistingSelectPpiView';
import UpdatesListView from '../../views/UpdatesListView';
import PpsiGlobalApprovalView from 'views/PpsiGlobalApprovalView';
import ApprovalStatusView from 'views/ApprovalStatusView';
import PpiCreateFromPublishedLocalPpiView from '../../views/PpiCreateFromPublishedLocalPpiView';
import ReportsListView from 'views/ReportsListView';
import TotalRangeDishStatisticsView from 'views/TotalRangeDishStatisticsView';
import SearchListView from 'views/SearchListView';
import PpiCreateVariantView from 'views/PpiCreateVariantView';
import CoWorkerEngagementReportView from 'views/CoWorkerEngagementReportView';
import CoWorkerEngagementReportListView from 'views/CoWorkerEngagementReportListView';
import UploadFileView from 'views/UploadFileView';
import PpsiCreateFromPublishedLocalPpsiView from 'views/PpsiCreateFromPublishedLocalPpsiView';
import UploadBomReportView from 'views/UploadBomReportView';
import GlobalPpsiGridView from 'views/GlobalPpsiGridView';
import FeedbackListView from 'views/FeedbackListView';
import PpsiPublishedListGlobalNirView from 'views/PpsiPublishedListGlobalNirView';
import PpsiCreateFromGlobalNirView from '../../views/PpsiCreateFromGlobalNirView';
// import { activeNirMarkets } from '../../utils/nirMarkets';
// import { getMarketName } from '../../features/app/selectors';
import MarketSettingsView from 'views/MarketSettingsView';
import { getMarketName, getConfigs } from '../../features/app/selectors';
import { FranchiseType } from '../../constants/franchiseType';
import NewUpdatesListView from 'views/NewUpdatesListView';

// import PpiCreateGlobalVariantView from 'views/PpiCreateGlobalVariantView';

const Routes = () => {
  const userMarket = useSelector(getMarketName);
  console.log(userMarket, 'userMarket');

  const franchiseType = useSelector(getConfigs).toJS().franchise;

  return (
    <Switch>
      <PrivateRoute exact from="/">
        <StartPage />
      </PrivateRoute>
      <Route path={loginRoute()} component={LoginView} />
      <Route path={logoutRoute()} component={LogoutView} />
      <Route path={authRoute()} component={AuthView} />
      <PrivateRoute
        exact
        path={newIngredientsRoute()}
        component={NewIngredientsView}
      />
      <PrivateRoute exact path={newDishesRoute()} component={NewDishesView} />
      <PrivateRoute
        exact
        path={updatesRoute()}
        component={NewUpdatesListView}
      />
      {/* <PrivateRoute
        exact
        path={newUpdatesRoute()}
        component={NewUpdatesListView}
      /> */}
      <PrivateRoute
        exact
        path={newGlobalIngredientsRoute()}
        component={NewIngredientsGlobalView}
      />
      <ProtectedRoute
        isRouteAllowed={
          franchiseType ? franchiseType === FranchiseType.INGKA : undefined
        }
        exact
        path={newGlobalDishesRoute()}
        component={NewGlobalPpsisView}
      />

      <PrivateRoute
        exact
        path={excludedIngredientsRoute()}
        component={IngredientsExcludedView}
      />
      <PrivateRoute
        exact
        path={ppiCreateVariantRoute()}
        component={PpiCreateVariantView}
      />
      <PrivateRoute
        exact
        path={draftPPIsRoute()}
        component={PpiDraftListView}
      />
      <PrivateRoute
        exact
        path={publishedPPIsRoute()}
        component={PpiPublishedListView}
      />
      <PrivateRoute exact path={ppiCreateRoute()} component={PpiCreateView} />
      <PrivateRoute
        exact
        path={ppiCreateFromExistingRoute()}
        component={PpiCreateFromExistingView}
      />
      <PrivateRoute
        exact
        path={globalSearchRoute()}
        component={SearchListView}
      />
      <PrivateRoute
        exact
        path={ppiCreateFromExistingSelectPpiRoute()}
        component={PpiCreateFromExistingSelectPpiView}
      />
      <PrivateRoute
        exact
        path={ppiCreateFromPublishedPpiRoute()}
        component={PpiCreateFromPublishedLocalPpiView}
      />
      <PrivateRoute
        exact
        path={ppsiCreateFromPublishedPpsiRoute()}
        component={PpsiCreateFromPublishedLocalPpsiView}
      />
      <PrivateRoute
        exact
        path={ppiInProgressRoute(':id')}
        component={PpiEditView}
      />
      <PrivateRoute
        exact
        path={ppiPublishedRoute(':id')}
        component={PpiPublishedView}
      />
      <PrivateRoute
        exact
        path={draftPPSIsRoute()}
        component={PpsiDraftListView}
      />
      <PrivateRoute
        exact
        path={dataReportRoute()}
        component={ReportsListView}
      />
      <PrivateRoute
        exact
        path={totalRangeDishStatisticsRoute()}
        component={TotalRangeDishStatisticsView}
      />
      <PrivateRoute
        exact
        path={coWorkerEngagementReportMarketRoute()}
        component={CoWorkerEngagementReportView}
      />
      <PrivateRoute
        exact
        path={coWorkerEngagementReportRoute(':id')}
        component={CoWorkerEngagementReportView}
      />
      <PrivateRoute
        exact
        path={coWorkerEngagementReportListRoute()}
        component={CoWorkerEngagementReportListView}
      />
      <PrivateRoute
        exact
        path={approvedPPSIsRoute()}
        component={PpsiApprovedListView}
      />
      <PrivateRoute
        exact
        path={publishedPPSIsRoute()}
        component={PpsiPublishedListView}
      />
      <PrivateRoute
        exact
        path={approvalStatusPPSIsRoute()}
        component={ApprovalStatusView}
      />
      <PrivateRoute exact path={ppsiCreateRoute()} component={PpsiCreateView} />
      <PrivateRoute
        exact
        path={ppsiCreateVariantRoute()}
        component={PpsiCreateVariantView}
      />
      {/* <PrivateRoute
        exact
        path={globalVariantPpiRoute()}
        component={PpiCreateGlobalVariantView}
      /> */}
      <PrivateRoute
        exact
        path={ppsiCreateFromExistingRoute()}
        component={PpsiCreateFromExistingView}
      />
      <PrivateRoute
        exact
        path={ppsiInProgressRoute(':id')}
        component={PpsiEditView}
      />
      <PrivateRoute
        exact
        path={globalReviewApprovalRoute(':id')}
        component={PpsiGlobalApprovalView}
      />
      <PrivateRoute
        exact
        path={globalMarketReviewRoute(':id')}
        component={WaitingForGlobalReview}
      />
      <PrivateRoute
        exact
        path={ppsiPublishedRoute(':id')}
        component={PpsiPublishedView}
      />
      <PrivateRoute
        exact
        path={unpublishedPpsisRoute()}
        component={UnpublishedDishListView}
      />
      <PrivateRoute
        exact
        path={unpublishedPpisRoute()}
        component={UnpublishedIngredientListView}
      />
      <PrivateRoute
        exact
        path={globalWaitingReviewRoute()}
        component={GlobalReviewSummary}
      />
      <PrivateRoute
        exact
        path={excludedDishesRoute()}
        component={DishesExcludedView}
      />
      <PrivateRoute exact path={uploadFileRoute()} component={UploadFileView} />

      <PrivateRoute
        exact
        path={globalPpsisRoute()}
        component={PpsiPublishedListView}
      />

      <PrivateRoute
        exact
        path={globalPpsisRoute()}
        component={GlobalPpsiGridView}
      />
      <PrivateRoute exact path={feedbackRoute()} component={FeedbackListView} />

      <PrivateRoute // Market Settings
        exact
        path={marketSettingsRoute()}
        component={MarketSettingsView}
      />

      <ProtectedRoute // NIR
        isRouteAllowed={
          franchiseType ? franchiseType !== FranchiseType.INGKA : undefined
        }
        exact
        path={bomReportNirRoute(userMarket)}
        component={UploadBomReportView}
      />

      <ProtectedRoute // NIR
        isRouteAllowed={
          franchiseType ? franchiseType !== FranchiseType.INGKA : undefined
        }
        exact
        path={globalPpsisNirRoute(userMarket)}
        component={PpsiPublishedListGlobalNirView}
      />

      <ProtectedRoute // NIR
        isRouteAllowed={
          franchiseType ? franchiseType !== FranchiseType.INGKA : undefined
        }
        exact
        path={globalPppsiDetailsNirRoute(':market', ':id')}
        component={PpsiPublishedView}
      />

      <ProtectedRoute // NIR
        isRouteAllowed={
          franchiseType ? franchiseType !== FranchiseType.INGKA : undefined
        }
        exact
        path={ppsiCreateFromGlobalNirRoute(':market')}
        component={PpsiCreateFromGlobalNirView}
      />

      <Route component={NotFoundView} />
    </Switch>
  );
};

export default Routes;
